<template>
  <div>
    <base-header class="bg-vg-gradient pb-6 pb-8 pt-5 pt-md-8"></base-header>
    <div class="container-fluid mt--9">
      <div class="row">
        <div class="col-xl-12">
          <div class="card shadow">
            <div class="card-header border-0">
              <div class="row align-items-center">
                <div class="col">
                  <h3 class="mb-0">Firma Yetkilileri</h3>

                </div>
              </div>
            </div>

            <div class="table-responsive" v-loading="loading">
              <base-table thead-classes="thead-light"
                          :data="companyUsers"
                          v-if="companyUsers != null "
              >
                <template slot="columns">
                  <th>Yetkili</th>
                  <th>Email</th>
                  <th>Tarih</th>
                  <th>Durum</th>
                  <th></th>
                </template>
                <template slot-scope="{row}">
                  <th scope="row">
                    <div class="media align-items-center">
                      <a href="#" class="avatar rounded-circle mr-3">
                        <img alt="Image placeholder" :src="'https://vizyonergenc.com/storage/'+row.users.avatar"/>
                      </a>
                      <div class="media-body">
                        <span class="name mb-0 text-sm">{{ row.users.name }}</span>
                      </div>
                    </div>
                  </th>
                  <td>{{ row.users.email }}</td>
                  <td class="first_follow_date">{{ row.created_at }}</td>
                  <td>
                    <badge v-if="row.status===1" class="badge-dot mr-4" type="success">
                      <i class="bg-success"></i>
                      <span class="status">Aktif Hesap</span>
                    </badge>
                    <badge v-else class="badge-dot mr-4" type="danger">
                      <i class="bg-danger"></i>
                      <span class="status">Pasif Hesap</span>
                    </badge>
                  </td>
                  <td>
                    <button class="btn btn-danger btn-sm" v-if="row.status === passive" @click="changeUserStatus(active,row.id)">Aktif Yap</button>
                    <button class="btn btn-success btn-sm" v-else @click="changeUserStatus(passive,row.id)">Pasif Yap</button>
                  </td>
                </template>
              </base-table>
            </div>
            <div class="card-footer py-4 d-flex justify-content-between align-items-center">
              <small class="mb-0">Toplam: {{ total }}</small>
              <base-pagination v-model="currentPage" :total="total"></base-pagination>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line no-unused-vars
import * as axios from "axios";

export default {
  name: 'CompanyUser',
  data() {
    return {
      vm: null,
      loading: true,
      active:1,
      passive:0,
      companyUsers:[],
      followers:null,
      offset: 20,
      limit: 10,
      pageSizes: [5, 10, 15, 30, 50],
      total: 0,
      filterForm: {},
      currentPageSize: 10,
      currentPage: 1,
      alphabeticalSortingValue: "",
      status:null,
      options: [{
        value: 'asc',
        label: 'A dan Z ye'
      }, {
        value: 'desc',
        label: 'Z den A ya'
      }]
    };
  },
  mounted() {
    this.getCompanyUsers();
  },
  watch: {
    currentPage: {
      handler: "paginate",
      immediate: true
    }
  },
  methods: {
    getCompanyUsers() {
      let data = {
        offset: this.offset,
        limit: this.limit,
        company_id: this.$route.params.id,
      }
      axios.post('admin/company-user', data).then(response => {
        this.loading = false;
        this.companyUsers = response.data.results;
        this.total =response.data.new_request_requirements.total;
        this.followers = response.data.results;
        return response.data;
      })
          .catch(error => {
            this.loading = false;
            this.$notify.error({
              title: 'Bir hata meydana geldi',
              message: error.response.data.join(' ')
            });
          })
    },

    async prepareListData() {
      this.loading = true;
      let response = await this.getCompanyUsers();
      this.total = response.new_request_requirements.total;
      this.loading = false;
    },
    handleSizeChange(val) {
      this.currentPageSize = val;
      this.currentPage = 1;

      this.paginate();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.paginate();
    },
    async paginate() {
      this.offset = (this.currentPage - 1) * this.currentPageSize;
      this.limit = this.currentPageSize;
      this.loading = true;
      await this.prepareListData();
      this.loading = false;
    },
    clearPagination() {
      this.currentPage = 1;
      this.offset = (this.currentPage - 1) * this.currentPageSize;
    },
    changeUserStatus(status,id){
      this.loading = true;
      if (status == null || id == null){
        this.$notify.error({
          title: 'Bir hata meydana geldi',
          message: 'Bi hata meydana geldi',
        });
        return false;
      }
      let formData = new FormData();
      formData.append("status",status);
      formData.append("id",id);

      axios.post("admin/company-user/status",formData).then(response => {
        if (response.status == 200){
          this.getCompanyUsers();
        }
      })
      .catch(error => {
        this.loading = false;
        this.$notify.error({
          title: 'Bir hata meydana geldi',
          message: error.response.data.join(""),
        });
        return false;
      })




    }

  }
};
</script>

<style>
.pagi {
  color: green !important;

}
</style>
